import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';

export class OpenSameAddressAlertAction implements Action {
  constructor(
   
  ) {}
}



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-same-address-alert-dialog/family-plan-member-same-address-alert-dialog.action.ts